// Suscripción y cobro del Modo Turno (Planner #862, Entrega 1 — fix F3).
//
// `Payment.monto` guarda el importe BRUTO, con IVA: es el que efectivamente
// entra a la cuenta bancaria, y el mockup admin B aprobado lo muestra así
// ($107.100 para un plan de $90.000 netos). El precio pactado, NETO, sigue
// viviendo en `Subscription.price_net` (ver el docstring de
// `backend/app/billing/models.py::Payment.monto`). Este helper es el único
// lugar que calcula el prellenado de la caja de cobro, para que la UI y el
// modelo digan lo mismo.
// #1680 R38: misma regla que el backend (`billing/pricing.py`): IVA = neto x tasa
// redondeado al peso con la mitad hacia arriba; bruto = neto + IVA. Con neto
// 403277 y 0.19 da 479900 (el IVA exacto es 76622,63 -> 76623), no 479901.
const ivaRedondeado = (neto, ivaRate) => {
  // toFixed(6) quita el arrastre binario antes de decidir la mitad (x.5 sube).
  const exacto = Number((neto * Number(ivaRate || 0)).toFixed(6));
  return Math.floor(exacto + 0.5);
};

export const montoBrutoSugerido = (priceNet, ivaRate = "0.19") => {
  if (priceNet === null || priceNet === undefined || priceNet === "") return "";
  const neto = Number(priceNet);
  if (Number.isNaN(neto)) return "";
  return neto + ivaRedondeado(neto, ivaRate);
};

export const montoIvaSugerido = (priceNet, ivaRate = "0.19") => {
  if (priceNet === null || priceNet === undefined || priceNet === "") return "";
  const neto = Number(priceNet);
  if (Number.isNaN(neto)) return "";
  return ivaRedondeado(neto, ivaRate);
};

// G1 (revisor #862, 2ª pasada): `Number("")` da `0`, y `Number(x || 0)`
// también -- cualquier campo numérico de un formulario que se vacía por
// error (o a propósito, para retipear) termina mandando un `0` REAL al
// backend, indistinguible de "quiero 0". `handleGuardarEdicion` hacía
// exactamente eso con `price_net` y `grace_days`, y vaciar los dos campos
// del cajón de admin dejaba una suscripción `fundador` en $0 y sin gracia,
// con un 200 silencioso. Este es el ÚNICO punto de verdad para convertir un
// campo de formulario en lo que viaja en el payload: un campo vacío se
// traduce en "no lo mandes" (la clave queda ausente, `undefined`), nunca en
// `0`. Lo usan `handleCrear` y `handleGuardarEdicion` de `UsersAdmin.js`, y
// cualquier superficie nueva que escriba un número de billing tiene que
// pasar por acá -- es el mismo agujero que ya se cerró una vez en el alta
// (F1) y se reabrió en la edición (G1) por no compartir la lógica.
export const campoNumericoDeFormulario = (valor) => {
  if (valor === null || valor === undefined) return undefined;
  const texto = String(valor).trim();
  if (texto === "") return undefined;
  const numero = Number(texto);
  if (Number.isNaN(numero)) return undefined;
  return numero;
};

// B5 (revisor #862, Entrega 4, 4ª pasada) y B6 (5ª pasada): los DOS campos
// de plata de la caja de cobro -- el neto (`monto_neto`) y el bruto
// (`monto`) -- se reescribían desde varios lugares de `UsersAdmin.js` (el
// montaje, el alta, la edición y el registro de un pago corren `cargar()`,
// más los dos botones de pestaña), y cada arreglo anterior tapó un campo
// en un lugar y dejó el otro campo (o el mismo campo en otro lugar) sin
// tocar -- la MISMA clase de falla que motivó `campoNumericoDeFormulario`
// en la Entrega 1: B3 arregló el neto en los botones, B5 lo arregló en
// `cargar()`, y B6 destapó que el BRUTO nunca se había arreglado en
// NINGUNO de los dos. `valorInicialDeCobro` es la ÚNICA fuente para
// CUALQUIER campo de plata que se resetee al cambiar de concepto: recibe
// un booleano, no el string del concepto, para no acoplarse al valor
// exacto de `CONCEPTO_MENSUALIDAD` que vive en `UsersAdmin.js`, y el valor
// a heredar cuando SÍ es mensualidad -- cualquier otro concepto nace
// vacío, sin excepción y sin importar cuál sea.
export const valorInicialDeCobro = (esMensualidad, valorSiMensualidad) =>
  esMensualidad ? valorSiMensualidad : "";

// Nombrado por campo para que cada call site en `UsersAdmin.js` diga QUÉ
// está pidiendo, en vez de repetir el ternario de `valorInicialDeCobro` a
// mano en cada lugar (que es exactamente el patrón que encadenó B3 → B5 →
// B6: un tercer lugar donde cada campo aprende el concepto por su cuenta).
export const netoInicialDeCobro = (esMensualidad, priceNet) =>
  valorInicialDeCobro(esMensualidad, priceNet);

export const montoInicialDeCobro = (esMensualidad, priceNet, ivaRate) =>
  valorInicialDeCobro(esMensualidad, montoBrutoSugerido(priceNet, ivaRate));
